import DisbursementApprovalModal from './DisbursementApprovalModal.vue';

export default DisbursementApprovalModal;
